import { OrganizationType } from '../staff/organization-type.enum';
import { ArchiveCatalogNameRule } from './archive-catalog-name-rule.model';
import { ArchiveCatelogCreateType } from './archive-catelog-create-type.enum';
import { ArchiveFileSummary } from './archive-file-summary.model';
import { ArchiveFileSyncRule } from './archive-file-sync-rule.model';
import { ArchiveStatus } from './archive-status.enum';
export class ArchiveCatalog extends ArchiveFileSummary {
  [key: string]: any;
  createType?: ArchiveCatelogCreateType;
  projectId?: number;
  sectionType?: OrganizationType;
  sectionId?: number;
  dwTypeCode?: string;
  dwTypeName?: string;
  sectionItemId?: number;
  materialTypeId?: number;
  materialModelId?: number;
  parentId?: number;
  nameRule?: ArchiveCatalogNameRule = new ArchiveCatalogNameRule();
  fileSyncRules?: Array<ArchiveFileSyncRule>;
  dynamicName?: string;
  staticName?: string;
  name?: string;
  leaf?: boolean = false;
  level?: number;
  volumeCount?: number;
  lockVolumeCount?: number;
  unlockVolumeCount?: number;
  volumeTime?: number;
  volumeTimeLong?: number;
  createUnit?: string;
  status?: ArchiveStatus;
  sortOrder?: number;
  path?: string;
  comment?: string;
  formatSortOrder?: string;
  // 前端自用
  children?: ArchiveCatalog[] = [];
  expanded?: boolean = false;
  firstChild?: boolean = false;
  pathDisplay?: string;
  hasVolumns?: boolean = false;
  readonly?: boolean = false;
}
